import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import { Layout } from "@/components/Layout";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/dashboard";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Logged in");
      navigate(from, { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout hideFooter>
      <div className="min-h-[calc(100vh-64px)] flex items-center justify-center px-4 py-12 bg-grid bg-grid-fade">
        <div className="w-full max-w-md surface p-8" data-testid="login-card">
          <div className="section-label mb-2">— MEMBER ACCESS</div>
          <h1 className="font-chivo font-black text-3xl text-white uppercase tracking-tight mb-6">Login</h1>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="font-mono text-xs text-[#9CA3AF] tracking-widest uppercase block mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="input-rugged"
                data-testid="login-email-input"
                autoComplete="email"
              />
            </div>
            <div>
              <label className="font-mono text-xs text-[#9CA3AF] tracking-widest uppercase block mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="input-rugged"
                data-testid="login-password-input"
                autoComplete="current-password"
              />
            </div>
            {error && <div className="text-sm font-mono text-[#EF4444]" data-testid="login-error">{error}</div>}
            <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit-button">
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
          <div className="mt-6 flex justify-between font-mono text-xs text-[#9CA3AF]">
            <Link to="/forgot-password" className="hover:text-[#00D4FF]" data-testid="login-forgot-link">Forgot password?</Link>
            <Link to="/register" className="hover:text-[#00D4FF]" data-testid="login-register-link">Create account →</Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
